<div class="dialog-title">Download Excel Report</div>

<form [formGroup]="formGrp">

  <div class="form-field" fxLayout="row wrap">
    <mat-form-field fxFlex="50" class="left">
      <mat-label>Start Date</mat-label>
      <input formControlName="startDate" matInput [matDatepicker]="startDate" #ref_start (click)="startDate.open()"
        [max]="maxStartDate" (dateInput)="onChangeStartDate(ref_start.value)" readonly required />
      <mat-error>Start Date is required</mat-error>
      <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
      <mat-datepicker #startDate></mat-datepicker>
    </mat-form-field>

    <mat-form-field fxFlex="50" class="right">
      <mat-label>End Date</mat-label>
      <input formControlName="endDate" matInput [matDatepicker]="endDate" #ref_end (click)="endDate.open()" [max]="currentDate"
        [min]="minEndDate" (dateInput)="onChangeEndDate(ref_end.value)" readonly required />
      <mat-error>End Date is required</mat-error>
      <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
      <mat-datepicker #endDate></mat-datepicker>
    </mat-form-field>
  </div>
</form>

<div class="dialog-buttons">
  <button mat-button color="primary" [mat-dialog-close]="false">Cancel</button>
  <button mat-button color="primary" [mat-dialog-close]="false"  [disabled]="formGrp.invalid" (click)="downloadExcel(formGrp.valid)">
    Download
  </button>
</div>